import { getImageProps } from "next/image"
import { computeImageDimensions } from "./computeImageDimensions"
import { optimizeStoryblokImage } from "./optimizeStoryblokImage"

export function getStoryblokBackgroundImageSet(src: string | undefined) {
    if (!src) return

    const optimizedSrc = optimizeStoryblokImage(src)
    const imageDimensions = computeImageDimensions(optimizedSrc)
    const {
        props: { srcSet },
    } = getImageProps({ alt: "", src: optimizedSrc, ...imageDimensions })

    if (!srcSet) return

    const imageSet = srcSet
        .split(", ")
        .map((str) => {
            const [url, dpi] = str.split(" ")

            return `url("${url}") ${dpi}`
        })
        .join(", ")

    return `image-set(${imageSet})`
}
